import { Base, Component } from '@/vue-property-decorator'
import { useFooterStore } from '../../store'
import { useI18n } from '@/i18n'
import style from './style.module.scss'

/**公司信息 */
@Component<CompanyInfo>({
  name: 'CompanyInfo'
})
export default class CompanyInfo extends Base {
  private get footerInfos() {
    return this.store.footerInfos
  }
  store = useFooterStore()
  private renderInfoArea() {
    if (this.footerInfos?.companyInfo) {
      const { isDefault, customContent } = this.footerInfos.companyInfo
      const companyInfo = isDefault ? this.renderDefault : customContent

      return (
        <div class={style.infoArea}>
          <inner-html type="div" text={companyInfo} class={style.text} />
        </div>
      )
    }
  }

  private get renderDefault() {
    if (!this.footerInfos?.companyInfo) return ''
    const { companyName, issuingAuthority, licenseKey } =
      this.footerInfos.companyInfo
    const { t } = useI18n()
    const oldList = [companyName, issuingAuthority, licenseKey]
    const str = t(`lobby.footer.companyInfo`).toString()
    const list = str.split('****')
    let newStr = ''
    for (let i = 0; i < oldList.length; i++) {
      newStr = newStr + list[i] + oldList[i]
    }
    return newStr + list[list.length - 1]
  }

  render() {
    if (this.footerInfos?.companyInfoStatus) return <template></template>
    return <div class={{ 'company-info': true }}>{this.renderInfoArea()}</div>
  }
}
